import { SVGProps } from 'react';

const SvgPersonPin = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
        <path d="M12.667 1.333H3.333A1.333 1.333 0 0 0 2 2.667V12a1.333 1.333 0 0 0 1.333 1.333H6l2 2 2-2h2.667c.733 0 1.333-.6 1.333-1.333V2.667c0-.734-.6-1.334-1.333-1.334Zm0 10.667h-3.22L8 13.447 6.553 12h-3.22V2.667h9.334V12ZM8 7.333c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2Zm0-2.666c.367 0 .667.3.667.666C8.667 5.7 8.367 6 8 6a.669.669 0 0 1-.667-.667c0-.366.3-.666.667-.666Zm4 5.72C12 8.72 9.353 8 8 8c-1.353 0-4 .72-4 2.387v.946h8v-.946ZM5.653 10C6.147 9.66 7.14 9.333 8 9.333c.86 0 1.853.327 2.347.667H5.653Z" />
    </svg>
);
export default SvgPersonPin;
